<template>
    <div class="container-fluid pt-3">
        <div class="top">
            <div class="title">
                <h1>{{ t("notifications-title") }}</h1>
            </div>
        </div>
        <div v-show="addedFilters">
            <filter-bar
                ref="filterBar"
                @changed="updateFilters"
                :show-labels="true"
                :filters="extraFilters"
            />
            <div class="clearfix"></div>
        </div>
        <modal
            ref="notificationPreview"
            :startsOpen="false"
            id="notificationPreview"
            @hide="() => {}"
            v-bind:class="{ 'modal-wide': true }"
        >
            <template slot="title">{{ t("notifications-modal-title") }}</template>
            <template slot="body">
                <iframe
                    src=""
                    frameborder="0"
                    style="width: 100%; height: 60vh"
                    ref="iframe"
                >
                </iframe>
            </template>
        </modal>
        <div class="row stats top-stats">
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="message-info">
                        <div class="icon-info-wrapper">
                            <div class="div-icon">
                                <Icon icon-class="ui-message-chat-square" size="13" />
                            </div>
                            <div class="info">
                                <div class="number">
                                    {{ formatNumber(stats.total) }}
                                </div>
                                <div class="label">{{ t("notifications-stats-total") }}</div>
                            </div>
                        </div>
                        <Segments url="/notifications/create-segment" :filters="filters" />
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-mail-02" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">
                                {{ formatNumber(stats.email) }}
                            </div>
                            <div class="label">{{ t("notifications-stats-email") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-message-text-square-01" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">{{ formatNumber(stats.sms) }}</div>
                            <div class="label">{{ t("notifications-stats-sms") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <span class="mdi mdi-whatsapp" style="font-size: 36px;"></span>
                        </div>
                        <div class="info">
                            <div class="number">
                                {{ formatNumber(stats.whatsapp) }}
                            </div>
                            <div class="label">{{ t("notifications-stats-whatsapp") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <span class="mdi mdi-whatsapp" style="font-size: 36px;"></span>
                        </div>
                        <div class="info">
                            <div class="number">
                                {{ formatNumber(stats.oficial_whatsapp) }}
                            </div>
                            <div class="label">{{ t("notifications-stats-oficial_whatsapp") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md" v-if="$module('rcs')">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-message-notification-square" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">{{ formatNumber(stats.rcs) }}</div>
                            <div class="label">{{ t("notifications-stats-rcs") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row stats top-stats">
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-check" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">{{ formatNumber(stats.accepted) }}</div>
                            <div class="label">{{ t("notifications-stats-accepted") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-send-01" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">{{ formatNumber(stats.sent) }}</div>
                            <div class="label">{{ t("notifications-stats-sent") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="fail-info">
                        <div class="icon-info-wrapper">
                            <div class="div-icon">
                                <Icon icon-class="ui-alert-circle" size="13" />
                            </div>
                            <div class="info">
                                <div class="number">
                                    {{ formatNumber(stats.failed) }}
                                </div>
                                <div class="label">{{ t("notifications-stats-failed") }}</div>
                            </div>
                        </div>
                        <button
                            @click="retryFailed"
                            :aria-label="t('notifications-actions-retry_failed_aria')"
                        >
                            <Icon
                                icon-class="ui-refresh-ccw-01"
                                size="6"
                                :tooltip="t('notifications-actions-retry_failed_tooltip')"
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="schedule-info">
                        <div class="icon-info-wrapper">
                            <div class="div-icon">
                                <Icon icon-class="ui-calendar" size="13" />
                            </div>
                            <div class="info">
                                <div class="number">
                                    {{ formatNumber(stats.scheduled) }}
                                </div>
                                <div class="label">{{ t("notifications-stats-scheduled") }}</div>
                            </div>
                        </div>
                        <button
                            @click="cancel()"
                            :aria-label="t('notifications-actions-cancel_scheduled_aria')"
                        >
                            <Icon
                                icon-class="ui-x-close"
                                size="6"
                                :tooltip="t('notifications-actions-cancel_scheduled_tooltip')"
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md">
                <div class="box">
                    <div class="icon-info-wrapper">
                        <div class="div-icon">
                            <Icon icon-class="ui-loading-01" size="13" />
                        </div>
                        <div class="info">
                            <div class="number">
                                {{ formatNumber(stats.queued) }}
                            </div>
                            <div class="label">{{ t("notifications-stats-queued") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="ready && addedFilters">
            <grid
                source="notifications"
                :filters="filters"
                :showSearch="false"
                @loaded="updated"
            >
                <template v-slot:rows="grid">
                    <thead>
                        <tr>
                            <th>{{ t("notifications-table-message") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="notification in grid.data"
                            :key="notification.id"
                        >
                            <td>
                                <div class="badges">
                                    <span
                                        class="badge"
                                        :class="classes[notification.status]"
                                    >
                                        {{ t(notification.status) }}:
                                        <span
                                            v-if="
                                                notification.status ===
                                                    'scheduled' ||
                                                notification.status === 'queued'
                                            "
                                            ><human-date
                                                :date="notification.notify_at"
                                                :format="t('dates-format_date_time')"
                                            ></human-date
                                        ></span>
                                        <span
                                            v-if="
                                                notification.status === 'sent' ||
                                                notification.status === 'accepted'
                                            "
                                            ><human-date
                                                :date="notification.sent_at"
                                                :format="t('dates-format_date_time')"
                                            ></human-date
                                        ></span>
                                        <span
                                            v-if="
                                                notification.status === 'failed'
                                            "
                                        >
                                            {{ notification.fail_reason }}</span
                                        >
                                    </span>
                                    <span class="badge">
                                        {{ t(notification.method === 'whatsapp-cloud' ? 'whatsapp_official' : notification.method) }}:
                                        <template v-if="notification.recipient_address">
                                            <router-link :to="`/client/${notification.clients_id}#event-${notification.id}`">
                                                {{ notificationClientLabel(notification) }}
                                            </router-link>
                                        </template>
                                        <span
                                            v-else-if="
                                                notification.method === 'email'
                                            "
                                            >{{
                                                notification.client_email
                                            }}</span
                                        >
                                        <router-link v-else :to="`/client/${notification.clients_id}#event-${notification.id}`">
                                          <span>
                                              {{
                                                  formatPhone(notification.client_phone)
                                              }}
                                          </span>
                                        </router-link>
                                    </span>
                                    <span
                                        v-if="notification.sender_alias"
                                        class="badge"
                                    >
                                        {{ t("notifications-table-sender") }}: {{ notification.sender_alias }}
                                    </span>
                                    <NotificationRecipientChip
                                        :address="notification.recipient_address"
                                        :method="notification.method"
                                    />
                                </div>

                                <div class="notificationBody">
                                    <span>
                                      {{
                                          notification.method === "email"
                                              ? `${t('notifications-content-subject_prefix')}${notification.subject} - `
                                              : notification.body
                                      }}
                                    </span>
                                    <button v-if="notification.method === 'email'" class="btn btn-small btn-primary" @click="activeNotification = notification">
                                        {{ t("notifications-actions-view_email_body") }}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </grid>
        </div>
    </div>
</template>
<style lang="scss">
.page-content.notifications {
    max-width: 100%;
    .badges {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }
    .notificationBody {
        padding: 20px 0px;
        display: flex;
        align-items: center;
        gap: 8px;

        span {
            width: fit-content;
        }
    }
}
.schedule-info,
.fail-info,
.message-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    & > button {
        margin-left: auto;
        background-color: transparent;
        border: none;
    }
}
</style>
<style lang="scss" scoped>
.info {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
}

.icon-info-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.div-icon {
    color: var(--secondary);
    padding-top: 5px;
}

@media (max-width: 1200px) {
    .schedule-info,
    .fail-info,
    .message-info {
        align-items: flex-start;

        & > button {
            padding-top: 6px;
            background-color: transparent;
            border: none;
        }
    }
    .create-segments-btn {
        padding: 6px 6px 1px 6px !important;
    }
    .icon-info-wrapper {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
<script>
import keviApi from "../keviApi";
import HumanDate from "../components/human-date/human-date";
import Modal from "../components/modal/modal";
import Segments from "../components/segments/segments";
import Icon from "../components/icon/icon";
import NotificationRecipientChip from "@/components/ui/notification-recipient-chip.vue";
import phoneMixin from "@/mixins/phone-mixin";

export default {
    components: { Modal, HumanDate, Segments, Icon, NotificationRecipientChip },
    mixins: [phoneMixin],
    data: function () {
        return {
            notifications: [],
            classes: {
                scheduled: "badge-warning",
                queued: "badge-warning",
                sent: "badge-success",
                accepted: "badge-info",
                failed: "badge-danger",
            },
            activeNotification: {
                id: null,
                body: null,
                subject: null,
            },
            filters: {},
            ready: false,
            addedFilters: false,
            automations: [],
            senders: [],
            extraFilters: [],
            stats: {
                total: 0,
                sent: 0,
                failed: 0,
                scheduled: 0,
                queued: 0,
                email: 0,
                sms: 0,
                whatsapp: 0,
                oficial_whatsapp: 0,
                accepted: 0,
            },
        };
    },
    mounted() {
        (async () => {
            document.getElementsByTagName("title")[0].innerText =
                this.t("notifications-page_title");
            await Promise.all([this.loadAutomations(), this.loadSenders()]);
            const filterBar = this.$refs.filterBar;
            filterBar.addFilter("period");
            if (this.automations.length > 0) {
                this.extraFilters.push({
                    component: "selectbox",
                    label: this.t("notifications-filters-automation"),
                    name: "automation_id",
                    options: this.automations.map((automation) => {
                        return {
                            value: automation.id,
                            label: automation.title,
                        };
                    }),
                    removable: true,
                });
            }
            if (this.senders.length > 0) {
                this.extraFilters.push({
                    component: "checkbox",
                    label: this.t("notifications-filters-sender-label"),
                    name: "places_senders_id",
                    options: {
                        options: this.senders.map((sender) => ({
                            value: sender.id,
                            label: `${sender.alias} (${sender.sender_name || sender.channel})`,
                        })),
                        icon: "fa-paper-plane",
                    },
                    removable: true,
                });
            }
            this.extraFilters.push({
                component: "checkbox",
                label: this.t("notifications-filters-status-label"),
                name: "status",
                options: {
                    options: [
                        {
                            value: "accepted",
                            label: this.t(
                                "notifications-filters-status-options-accepted",
                            ),
                        },
                        {
                            value: "scheduled",
                            label: this.t(
                                "notifications-filters-status-options-scheduled",
                            ),
                        },
                        {
                            value: "sent",
                            label: this.t("notifications-filters-status-options-sent"),
                        },
                        {
                            value: "failed",
                            label: this.t("notifications-filters-status-options-failed"),
                        },
                        {
                            value: "queued",
                            label: this.t("notifications-filters-status-options-queued"),
                        },
                    ],
                    icon: "fa-tag",
                },
                removable: true,
            });
            this.extraFilters.push({
                component: "checkbox",
                label: this.t("notifications-filters-method-label"),
                name: "method",
                options: {
                    options: [
                        {
                            value: "email",
                            label: this.t("notifications-filters-method-options-email"),
                        },
                        {
                            value: "sms",
                            label: this.t("notifications-filters-method-options-sms"),
                        },
                        {
                            value: "whatsapp",
                            label: this.t("notifications-filters-method-options-whatsapp"),
                        },
                        {
                            value: "whatsapp-cloud",
                            label: this.t("notifications-filters-method-options-whatsapp_cloud"),
                        },
                    ].concat(this.$module('rcs') ? [{
                        value: "rcs",
                        label: this.t("notifications-filters-method-options-rcs"),
                    }] : []),
                    icon: "fa-tag",
                },
                removable: true,
            });
            this.addedFilters = true;
        })();
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        async loadAutomations() {
            const options = keviApi.getOptions(
                "notifications/automations",
                "GET",
            );
            this.automations = (await this.$http(options)).body.automations;
        },
        async loadSenders() {
            try {
                const options = keviApi.getOptions("senders", "GET");
                const response = await this.$http(options);
                this.senders = response.body?.my_senders || [];
            } catch (e) {
                this.senders = [];
            }
        },
        updateFilters(filters) {
            this.filters = filters;
            this.ready = true;
        },
        async retryFailed() {
            if (!confirm(this.t("notifications-confirmations-retry_failed", [this.stats.failed]))) {
                return;
            }
            const options = keviApi.getOptions("notifications/retry", "POST", {
                filters: this.filters,
            });
            await this.$http(options);
            await this.$store.dispatch(
                "notification/success",
                this.t("notifications-toasts-retry_success"),
            );
            window.setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        async cancel() {
            if (!confirm(this.t("notifications-confirmations-cancel_scheduled"))) {
                return;
            }
            const options = keviApi.getOptions("notifications/cancel", "POST", {
                filters: this.filters,
            });
            await this.$http(options);
            await this.$store.dispatch(
                "notification/success",
                this.t("notifications-toasts-cancel_success"),
            );
            window.setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        updated(response) {
            if (response.total) {
                this.stats.total = response.total;
            }
            if (response?.response?.stats) {
                for (let k in response.response.stats) {
                    this.stats[k] = response.response.stats[k];
                }
            }
            document
                .querySelector("body")
                .scrollTo({ top: 0, behavior: "smooth" });
        },
        formatNumber(number) {
            if (!number) {
                return 0;
            }
            return parseFloat(number).toLocaleString("pt-BR");
        },
        notificationClientLabel(notification) {
            const name = [notification.client_name, notification.client_lastname]
                .filter(Boolean)
                .join(" ")
                .trim();
            if (name) {
                return name;
            }
            if (notification.method === "email") {
                return notification.client_email || `#${notification.clients_id}`;
            }
            return this.formatPhone(notification.client_phone) || `#${notification.clients_id}`;
        },
    },
    watch: {
        activeNotification(notification) {
            if (notification.id && notification.method === "email") {
                const iframe = this.$refs.iframe;
                if (!iframe) return;
                const doc =
                    iframe.contentDocument || iframe.contentWindow.document;
                doc.open();
                doc.write(notification.body);
                doc.close();
                this.$refs.notificationPreview.open();
            }
        },
    },
};
</script>
